import { getResultsDTO } from '../../modules/getResults'
import { api } from './api'
import { subscribeListDTO } from './types'

export const getListPage = (listId: string) => {
  return api.get(`/lists/${listId}/page`)
}

export const subscribeList = (body: subscribeListDTO) => {
  const { listId, registerBody } = body
  return api.post(`/lists/${listId}`, registerBody, {
    headers: {
      'Content-type': 'application/json',
    },
  })
}

export const getResult = (body: getResultsDTO) => {
  const { listId, token } = body
  return api.get(`/lists/${listId}/confirm?token=${token}`, {
    headers: {
      'Content-type': 'application/json',
    },
  })
}